export * from './preview-modal.component';


// WEBPACK FOOTER //
// ./src/app/content/shared/components/preview-modal/index.ts